<div mat-dialog-title><mat-icon color="warn" class="spin">delete_outline</mat-icon> {{ 'toDelete' | translate }}</div>
<mat-dialog-content>
    {{data}}
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="false" data-cy="confirm-cancel-btn">
        {{ 'cancel' | translate }}</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true" data-cy="confirm-ok-btn">
        {{ 'delete' | translate }}</button>
</mat-dialog-actions>